import { tableController, translate } from 'magner';
import type { Company } from 'features/residents/companies/types/hubstr';
import { ResidentList, Tag } from 'features/residents/types/hubstr';
import { values } from 'lodash-es';

const companyTable = tableController<Company>({
  emptyText: translate('hubstr.resident.companies.table.not_found'),
  rowLink: (row) => {
    const residentId = window.location.pathname.replace('/admin/residents/', '').replace(/\/companies.*/, '');
    return { name: 'company', params: { id: row.id }, query: { resident: residentId } };
  },
  columns: [
    {
      prop: 'logo',
      label: translate('hubstr.resident.companies.table.logo'),
      view: {
        // @ts-ignore
        type: 'image',
        // @ts-ignore
        nestedKey: 'big',
      },
    },
    {
      prop: 'name',
      label: translate('hubstr.resident.companies.table.name'),
      width: 200,
    },
    {
      prop: 'associationAreas',
      label: translate('hubstr.resident.companies.table.areas'),
      view: {
        type: 'tags',
      },
    },
    {
      prop: 'associationUserPosition',
      label: translate('hubstr.resident.companies.table.user_position'),
      view: {
        type: 'tags',
      },
    },
  ],
});

export default companyTable;
